import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWineBottleGlass = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M8.18,9.14V1.5H4.36V9.14h0A6.42,6.42,0,0,0,1.5,14.49v8h9.55v-8A6.43,6.43,0,0,0,8.18,9.14Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 2.45,
			y1: 1.5,
			x2: 10.09,
			y2: 1.5
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "plan2plate-icon",
			cx: 6.27,
			cy: 16.3,
			rx: 1.91,
			ry: 2.39
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M14.86,8.18H22.5a0,0,0,0,1,0,0v5.73a3.82,3.82,0,0,1-3.82,3.82h0a3.82,3.82,0,0,1-3.82-3.82V8.18a0,0,0,0,1,0,0Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 18.68,
			y1: 22.5,
			x2: 18.68,
			y2: 17.73
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 21.55,
			y1: 22.5,
			x2: 15.82,
			y2: 22.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 14.86,
			y1: 12.95,
			x2: 22.5,
			y2: 12.95
		})
	]
});
const ForwardRef = forwardRef(SvgWineBottleGlass);
export default ForwardRef;
